import {
   Button,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerFooter,
   DrawerHeader,
   DrawerOverlay,
   DrawerProps,
   useDisclosure,
} from "@chakra-ui/react";
import { useCookies } from "react-cookie";
import {
   handleAnalyticsCookies,
   handleFunctionalCookies,
   handleRejectAll,
   handleUncategorizedCookies,
} from "../cookie.helper";
import CookiePolicyModal from "./cookie-policy-modal.component";

const CookieBanner = ({ onClose, isOpen }: DrawerProps) => {
   const [_, setCookie, removeCookie] = useCookies(["cookieyes-consent"]);
   const {
      isOpen: isPolicyOpen,
      onClose: onClosePolicy,
      onOpen: onOpenPolicy,
   } = useDisclosure();

   const onReject = () => {
      setCookie("cookieyes-consent", true);
      handleRejectAll(removeCookie);
   };

   const onAcceptAll = () => {
      setCookie("cookieyes-consent", true);
      handleFunctionalCookies(setCookie);
      handleAnalyticsCookies(setCookie);
      handleUncategorizedCookies(setCookie);
      onClose();
   };

   const onCustomize = () => {
      onClose();
      onOpenPolicy();
   };

   return (
      <>
         <CookiePolicyModal isOpen={isPolicyOpen} onClose={onClosePolicy} />
         {isOpen && (
            <Drawer isOpen placement="bottom" onClose={onClose}>
               <DrawerOverlay />
               <DrawerContent overflow="scroll">
                  <DrawerCloseButton />
                  <DrawerHeader>We value your privacy</DrawerHeader>

                  <DrawerBody>
                     We use cookies to enhance your browsing experience, serve
                     personalized ads or content, and analyze our traffic. By
                     clicking "Accept All", you consent to our use of cookies.
                  </DrawerBody>

                  <DrawerFooter gap="1rem">
                     <Button
                        onClick={onCustomize}
                        variant="outline"
                        colorScheme="brandBlue"
                        color="brandBlue.600"
                        backgroundColor="white"
                        borderWidth="2px"
                        borderColor="brandBlue.600"
                        _hover={{
                           color: "white",
                           backgroundColor: "brandBlue.600",
                        }}
                     >
                        Customize
                     </Button>
                     <Button
                        onClick={onReject}
                        variant="outline"
                        colorScheme="brandBlue"
                        color="brandBlue.600"
                        backgroundColor="white"
                        borderWidth="2px"
                        borderColor="brandBlue.600"
                        _hover={{
                           color: "white",
                           backgroundColor: "brandBlue.600",
                        }}
                     >
                        Reject All
                     </Button>
                     <Button
                        onClick={onAcceptAll}
                        variant="solid"
                        colorScheme="brandBlue"
                        borderWidth="2px"
                        borderColor="brandBlue.600"
                        _hover={{
                           color: "brandBlue.600",
                           backgroundColor: "white",
                        }}
                     >
                        Accept All
                     </Button>
                  </DrawerFooter>
               </DrawerContent>
            </Drawer>
         )}
      </>
   );
};

export default CookieBanner;
